/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val3_TitleInputs */

const en_st_val3_title = /** @type {(inputs: St_Val3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One handover package`)
};

const id_st_val3_title = /** @type {(inputs: St_Val3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu paket serah terima`)
};

/**
* | output |
* | --- |
* | "One handover package" |
*
* @param {St_Val3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val3_title = /** @type {((inputs?: St_Val3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val3_title(inputs)
	return en_st_val3_title(inputs)
});